function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 8a8 8 0 1116 0A8 8 0 010 8zm7-3a1 1 0 00-2 0v6a1 1 0 102 0V5zm3-1a1 1 0 011 1v6a1 1 0 11-2 0V5a1 1 0 011-1z",
  fill: "#FFA310"
});

function SvgPause(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0wIDhDMCAzLjU4MTcyIDMuNTgxNzIgMCA4IDBDMTIuNDE4MyAwIDE2IDMuNTgxNzIgMTYgOEMxNiAxMi40MTgzIDEyLjQxODMgMTYgOCAxNkMzLjU4MTcyIDE2IDAgMTIuNDE4MyAwIDhaTTcgNUM3IDQuNDQ3NzIgNi41NTIyOCA0IDYgNEM1LjQ0NzcyIDQgNSA0LjQ0NzcyIDUgNVYxMUM1IDExLjU1MjMgNS40NDc3MiAxMiA2IDEyQzYuNTUyMjggMTIgNyAxMS41NTIzIDcgMTFWNVpNMTAgNEMxMC41NTIzIDQgMTEgNC40NDc3MiAxMSA1VjExQzExIDExLjU1MjMgMTAuNTUyMyAxMiAxMCAxMkM5LjQ0NzcxIDEyIDkgMTEuNTUyMyA5IDExVjVDOSA0LjQ0NzcyIDkuNDQ3NzEgNCAxMCA0WiIgZmlsbD0iI0ZGQTMxMCIvPgo8L3N2Zz4K";
export { SvgPause as ReactComponent };